import { render, staticRenderFns } from "./MailNotifyTemplate.vue?vue&type=template&id=2be7546b&"
import script from "./MailNotifyTemplate.vue?vue&type=script&lang=ts&"
export * from "./MailNotifyTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports